import React, { Component } from 'react';
import Header from '@components/Header/Header';
import LetsConnect from '@components/LetsConnect/LetsConnect';
import Footer from '@components/Footer/Footer';

class Default extends Component {
  render() {
    const isMobile = this.props.pageWidth < 992;
    return (
      <React.Fragment>
        <Header pageWidth={this.props.pageWidth} />
        {!isMobile && <LetsConnect />}
        {this.props.children}
        <Footer pageWidth={this.props.pageWidth} />
      </React.Fragment>
    );
  }
}

export default Default;



// WEBPACK FOOTER //
// ./src/components/Layout/Default.jsx